export default __webpack_public_path__ + "static/media/history4.00c0a273.png";